<template>
  <div class="step1" v-if="content.show&&content.type==4">
    <p class="tips">你的毕业去向：<span class="direction-text">{{content.direction}}</span>，满足你设定的考虑因素吗？满足/不满足的分数是多少？</p>
    <div class="element-box" v-for="(item,zindex) in content.options">
      <p>{{item}}</p>
      <div class="score-option">
        <div class="left-box">
          <div class="col2" :class="status[zindex]==''?'satisfied':''" @click="IsSatisfied('满足',zindex)">满足</div>
          <div class="col2" :class="status[zindex]=='-'?'noSatisfied':''" @click="IsSatisfied('不满足',zindex)">不满足</div>
        </div>
        <ul class="direction-box">
          <li v-for="(item,index) in answer" class="col5" :class="[selected[zindex][index]?'selected':'',status[zindex]!='+'?'':'disable']" @click="selectCurrent(item,index,zindex)">{{item}}</li>
        </ul>
      </div>
    </div>
    <p class="tips">已设定<span class="protrude">{{chooseValue.length}}</span>个，还有{{content.options.length-chooseValue.length}}个</p>
  </div>
</template>
<script>
export default {
  props:{
    content:Object
  },
  data(){
    return{
      selected: [
          [false, false, false, false, false],
          [false, false, false, false, false],
          [false, false, false, false, false],
          [false, false, false, false, false],
          [false, false, false, false, false],
          [false, false, false, false, false],
          [false, false, false, false, false],
          [false, false, false, false, false],
          [false, false, false, false, false],
          [false, false, false, false, false]
        ],
      answer: ['1', '2', '3', '4', '5'],
      errors:["","","","","","","","","",""],
      status:["+","+","+","+","+","+","+","+","+","+"],
      chooseValue:[]
    }
  },
  methods:{
    IsSatisfied(txt,index){
      let rightAnswer = ''
      if(txt=="满足"){
        this.$set(this.status,index,'')
        rightAnswer = ''
      }else if(txt=="不满足"){
        this.$set(this.status,index,'-')
        rightAnswer='-'
      }
      this.chooseValue.map((item)=>{
        if(item.id==index+1){
          if(item.answer.indexOf('+')>=0){
             item.answer=item.answer.replace("+",rightAnswer)
          }else{
             item.answer=item.answer.replace("-",rightAnswer)
          }
        }
      })
      this.$set(this.errors,index,'')
    },
    selectCurrent(name,index,sub){
      // 判断是否已选择满足
      if(this.status[sub]=='+'){
        // this.$set(this.errors,sub,'先选择是否满足')
        this.$store.commit('showMessage', {
          message: "先选择'是否满足'",
          type: 'error'
        })        
      }else{
        let option = [false, false, false, false, false]
        option[index]=true
        this.$set(this.selected,sub,option)
        let data = {id:sub+1,answer:this.status[sub]+name}
        this.chooseValue.map((item,index)=>{
          if(item.id==sub+1){
            this.chooseValue.splice(index,1)
          }
        })
        this.chooseValue.push(data)
        this.chooseValue.sort((a,b)=>{return a.id-b.id})
        if(this.chooseValue.length==this.content.options.length){
          this.content.errorMessage=""
          this.$emit("listenToChildEvent",this.chooseValue,this.content.num)
        }
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
  .tips
    text-align:center
  .direction-text
    font-size:0.4rem
    font-weight:bold
    color:#DC6E5A
  .element-box:nth-child(even)
    background-color:#C2E8F1
    margin:0.1rem
    padding:0.1rem
  .element-box:nth-child(odd)
    background-color:#CDCDCD
    margin:0.2rem 0.1rem
    padding:0.1rem
  .score-option
    overflow:hidden
    .direction-box
      float:left
      width:60%
      li
        float:left
        background-color:#FFFFFF
        padding:0 0.15rem
        margin:0.1rem 0.05rem
        display: flex;
        display:-webkit-flex;
        justify-content: center;/*水平居中*/
        align-items: center;/*垂直居中*/
        -webkit-align-items:center;
        border:1px solid #BBBBBB
      .selected
        background-color:#434343
        color:#ffffff
      .col5
        width:5%
      .disable
        background-color:#f1f1f1
    .left-box
      float:left
      width:40%
      .col2
        float:left
        background-color:#959595
        color:#ffffff
        width:40%
        margin: 0.1rem
        text-align:center
        border-radius:6px
      .satisfied
        background-color:#00B3DE
      .noSatisfied
        background-color:#C31216
  .protrude
    color:#DC6E5A
    font-weight:bold
</style>
